/**
 * Phase 1 interim: PIN-gated "who's on shift today" page.
 * Kenny or the front-desk taps in a 4-digit PIN and toggles which
 * barbers are on shift. That controls whose calendars the booking
 * wizard shows for today.
 *
 * Replaced Phase 2 by a proper staff console with clock in/out.
 *
 * Week 2 build: PIN gate + toggle grid + Firestore write to /shifts/{today}.
 */
export default function Roster() {
  return (
    <div className="min-h-screen bg-page flex items-center justify-center px-6">
      <div className="max-w-md w-full bg-paper rounded-panel border border-edge-2 shadow-shell p-10 text-center">
        <p className="kd-kicker text-gold-text text-xs mb-4">
          KD Barbershop · Staff
        </p>
        <h1 className="font-serif text-3xl text-navy mb-3">Roster</h1>
        <p className="font-serif italic text-slate-body mb-8">
          Interim page — PIN gate + toggle grid ships Week 2.
        </p>
        <div className="inline-flex items-center gap-3 border border-edge-2 rounded-pill px-5 py-2 bg-white">
          <span className="w-2 h-2 rounded-full bg-red-accent animate-pulse" />
          <span className="kd-kicker text-slate-body text-xs">
            Scaffold live
          </span>
        </div>
      </div>
    </div>
  );
}
